export const DATE_DEFAULT_TIMEZONE = 'Europe/Warsaw';

export const DATE_API_FORMAT = 'YYYY-MM-DD';
export const DATE_DEFAULT_FORMAT = 'DD.MM.YYYY';
export const DATE_UNICODE_FORMAT = 'dd.MM.yyyy';

export const DATE_YEARLY_API_FORMAT = 'MM-DD';
export const DATE_YEARLY_DEFAULT_FORMAT = 'DD.MM';
export const DATE_YEARLY_UNICODE_FORMAT = 'dd.MM';

export const DATETIME_API_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATETIME_DEFAULT_FORMAT = 'DD.MM.YYYY HH:mm';
export const DATETIME_UNICODE_FORMAT = 'dd.MM.yyyy HH:mm';

export const TIME_API_FORMAT = 'HH:mm';
export const TIME_DEFAULT_FORMAT = 'HH:mm';
export const TIME_UNICODE_FORMAT = 'HH:mm';